/* ===========================================================
   EVM · Testimonios
   Fundido entre citas, navegación por rayitas y pausa al
   pasar el ratón o enfocar con el teclado.
   =========================================================== */

/* Con dos instancias de la sección en la misma página, el navegador
   ejecuta este archivo dos veces: si ya está definido, no se repite
   nada (ni la clase ni los listeners de documento). */
if (!customElements.get('evm-testimonios')) {

class EvmTestimonios extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.evm-tst__item'));
    if (this.items.length < 1) return;

    this.ticks = Array.from(this.querySelectorAll('.evm-tst__tick'));
    this.index = 0;
    this.paused = false;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.ticks.forEach((tick) => {
      tick.addEventListener('click', () => {
        this.stop();
        this.show(parseInt(tick.dataset.index, 10));
      });
    });

    // Flechas del teclado sobre la navegación
    this.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!this.contains(document.activeElement)) return;
      e.preventDefault();
      this.stop();
      this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1));
      const tick = this.ticks[this.index];
      if (tick) tick.focus();
    });

    ['pointerenter', 'focusin'].forEach((e) =>
      this.addEventListener(e, () => { this.paused = true; })
    );
    ['pointerleave', 'focusout'].forEach((e) =>
      this.addEventListener(e, () => { this.paused = false; })
    );

    if (this.dataset.autoplay === 'true' && this.items.length > 1 && !this.reduceMotion) {
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop();
  }

  show(i) {
    const total = this.items.length;
    const next = ((i % total) + total) % total;
    this.index = next;

    this.items.forEach((item, n) => {
      const on = n === next;
      item.classList.toggle('is-active', on);
      if (on) {
        item.removeAttribute('aria-hidden');
      } else {
        item.setAttribute('aria-hidden', 'true');
      }
    });

    this.ticks.forEach((tick, n) => {
      const on = n === next;
      tick.classList.toggle('is-active', on);
      tick.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  start() {
    this.stop();
    const secs = parseInt(this.dataset.speed, 10) || 7;
    this.timer = window.setInterval(() => {
      if (this.paused || !this.isVisible()) return;
      this.show(this.index + 1);
    }, secs * 1000);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  isVisible() {
    const r = this.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  revealBlock(blockId) {
    const item = this.querySelector(`[data-shopify-editor-block*="${blockId}"]`);
    if (!item) return;
    this.stop();
    this.show(this.items.indexOf(item));
  }
}

if (!customElements.get('evm-testimonios')) {
  customElements.define('evm-testimonios', EvmTestimonios);
}

/* ---------- Editor de temas ---------- */
document.addEventListener('shopify:block:select', (event) => {
  const host = event.target.closest('evm-testimonios');
  if (host && typeof host.revealBlock === 'function') host.revealBlock(event.detail.blockId);
});

}
